module.exports = __webpack_public_path__ + "static/img/msds.92030b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msds.jpg
// module id = dVmP
// module chunks = 1